import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4292a50d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "not-found" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "not-found__title" }, " Ошибка 404 ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "not-found__text" }, [
  /*#__PURE__*/_createTextVNode(" Кажется что-то пошло не так..."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Страницы, которую вы запрашиваете, не существует. Возможно"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" она устарела, была удалена или введен неверный адрес. ")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "not-found__link-row"
}
const _hoisted_5 = ["href"]

import {
  onMounted,
  ref,
} from 'vue'
import AnimatedEyes from '@/components/AnimatedEyes.vue'
import {useValidateIntegratorHost} from '@/uses/Partner/useValidateIntegratorHost'
import {
  EnvCodeEnum,
  useEnvStore,
} from '@/stores/useEnvStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'NotFoundView',
  setup(__props) {

const envStore = useEnvStore()
const {validate} = useValidateIntegratorHost()

const homeUrl = ref<string>()

const resolveHost = (): string => {
  return envStore.isEditable(EnvCodeEnum.VUE_APP_API_URL)
    ? envStore.getEnvValue(EnvCodeEnum.VUE_TESTHOST) || ''
    : document.location.hostname
}

const buildCandidate = (host: string): string | undefined => {
  const match = host.match(/^.+?\.sign\.(.+)$/)
  if (!match) {
    return undefined
  }
  return `lk.${match[1]}`
}

const init = async () => {
  const host = resolveHost()
  if (!host) {
    return
  }
  const candidate = buildCandidate(host)
  if (!candidate) {
    return
  }
  const ok = await validate(candidate)
  if (ok) {
    homeUrl.value = `https://${candidate}/`
  }
}

onMounted(() => {
  init()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AnimatedEyes, { class: "not-found__eyes" }),
    _hoisted_2,
    _hoisted_3,
    (homeUrl.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
          _createTextVNode(" Вернуться на "),
          _createElementVNode("a", {
            href: homeUrl.value,
            class: "not-found__link"
          }, "домашнюю страницу!", 8, _hoisted_5)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})